import { UseQueryOptions } from '@tanstack/react-query';
import { GenericTradeParams, TpSlValueState } from '@ui/features/Trade/types';
import { SlValidationResult } from '@ui/features/Trade/utils/validateStoppLossPrice';
import { TpValidationResult } from '@ui/features/Trade/utils/validateTakeProfitPrice';
import { useGasFee } from '@ui/hooks/useGasFee';
import { isEmpty } from 'lodash-es';

import { EditTpSlBaseline } from './getEditTpSlBaseline';
import { useEditTpSlConfirmBtnDisabled } from './useEditTpSlConfirmBtnDisabled';
import { useEstOrderEditTpSlGasLimit } from './useEstOrderEditTpSlGasLimit';

export const useEstOrderUpdateTpSlGasFee = <TSelect = BigInt>({
  baseline,
  genericTradeParams,
  tp,
  sl,
  tpValidation,
  slValidation,
  opts,
}: {
  baseline: EditTpSlBaseline | null;
  tp: TpSlValueState;
  sl: TpSlValueState;
  tpValidation: TpValidationResult | undefined;
  slValidation: SlValidationResult | undefined;
  opts?: Pick<UseQueryOptions<BigInt, Error, TSelect>, 'enabled'>;
} & GenericTradeParams) => {
  const isConfirmBtnDisabled = useEditTpSlConfirmBtnDisabled({
    baseline,
    tp,
    sl,
    tpValidation,
    slValidation,
  });

  const { data: estimateUpdateTpSlGasLimit } = useEstOrderEditTpSlGasLimit({
    genericTradeParams,
    tp,
    sl,
    opts: {
      enabled:
        !isConfirmBtnDisabled &&
        !isEmpty(tp.priceValue) &&
        (opts?.enabled ?? true),
    },
  });

  return useGasFee(estimateUpdateTpSlGasLimit);
};
